import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
    name: 'uppercase',
    standalone: false
})
export class UppercasePipe implements PipeTransform {
  transform(value: string): any {
    return _.upperCase(value);
  }
}
